<template>
    <div class="grcform">
        <GrcDB ref="GRCDB"></GrcDB>    
        <GrcDialog ref="Dialog"
            v-on:popupopened="SetPopupRef('Dialog')"
            v-on:popupclosed="SetPopupRef('')"
        ></GrcDialog>

        <div class="grc_fullwidth_lane" style="background-color:transparent;">
            <div class="grc_maincont_lane">
                <div class="maintitle" style="text-align:center; color:dodgerblue;"><i class="fas fa-calculator" style="margin-right:10px;"></i>{{title}}</div>
            </div>
        </div>

        <div class="grc_fullwidth_lane">
        <div class="grc_maincont_lane" style="padding:10px;">

            <div class="main_col_cont">
                <div class="main_col">
                    <div class="innerform" style="padding:8px 0px;" v-show="innerformid==1">

                        <table style="width:100%;" cellspacing="0" cellpadding="0">
                            <tr>
                                <td><span class="field_label">Havi bruttó fizetés: <span class="infobtn" @click="InfoBtnClick(0)"><i class="fas fa-info-circle"></i></span></span></td>
                                <td class="field_input">
                                    <GrcNum ref="txtHaviBruttoFizetes" v-model="txtHaviBruttoFizetes"
                                    grc_labeltext="" grc_labelmode="nolabel" grc_labelwidth="100px"
                                    grc_currency="Ft" grc_decimalplaces="0" grc_readonly="false"
                                    grc_textalign="right"
                                    v-on:grc-keydown-enter="SetControlToFocus('txtJutalomMasBer');"
                                    style="width:100%;"
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td><span class="field_label">2021 évben kapott jutalom vagy más bér jellegű jövedelem: <span class="infobtn" @click="InfoBtnClick(1)"><i class="fas fa-info-circle"></i></span></span></td>
                                <td class="field_input">
                                    <GrcNum ref="txtJutalomMasBer" v-model="txtJutalomMasBer"
                                    grc_labeltext="" grc_labelmode="nolabel" grc_labelwidth="100px"
                                    grc_currency="Ft" grc_decimalplaces="0" grc_readonly="false"
                                    grc_textalign="right"
                                    v-on:grc-keydown-enter="SetControlToFocus('txtOnalloJovedelem');"
                                    style="width:100%;"
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td><span class="field_label">Önálló jövedelem 2021-ben: <span class="infobtn" @click="InfoBtnClick(2)"><i class="fas fa-info-circle"></i></span></span></td>
                                <td class="field_input">
                                    <GrcNum ref="txtOnalloJovedelem" v-model="txtOnalloJovedelem"
                                    grc_labeltext="" grc_labelmode="nolabel" grc_labelwidth="100px"
                                    grc_currency="Ft" grc_decimalplaces="0" grc_readonly="false"
                                    grc_textalign="right"
                                    v-on:grc-keydown-enter="SetControlToFocus('txtEgyebJovedelem');"
                                    style="width:100%;"
                                    />
                                </td>
                            </tr>
                            <tr style="display:none">
                                <td><span class="field_label">Külön adózó jövedelem: <span class="infobtn" @click="InfoBtnClick(3)"><i class="fas fa-info-circle"></i></span></span></td>
                                <td class="field_input">
                                    <GrcNum ref="txtKulonAdozoJovedelem" v-model="txtKulonAdozoJovedelem"
                                    grc_labeltext="" grc_labelmode="nolabel" grc_labelwidth="100px"
                                    grc_currency="Ft" grc_decimalplaces="0" grc_readonly="false"
                                    grc_textalign="right"
                                    v-on:grc-keydown-enter="SetControlToFocus('txtEgyebJovedelem');"
                                    style="width:100%;"
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td><span class="field_label">Egyéb jövedelem: <span class="infobtn" @click="InfoBtnClick(4)"><i class="fas fa-info-circle"></i></span></span></td>
                                <td class="field_input">
                                    <GrcNum ref="txtEgyebJovedelem" v-model="txtEgyebJovedelem"
                                    grc_labeltext="" grc_labelmode="nolabel" grc_labelwidth="100px"
                                    grc_currency="Ft" grc_decimalplaces="0" grc_readonly="false"
                                    grc_textalign="right"
                                    v-on:grc-keydown-enter="SetControlToFocus('');"
                                    style="width:100%;"
                                    />
                                </td>
                            </tr>
                        </table>

                        <div style="width:100%; box-sizing:border-box; text-align:center; margin:10px 0px 0px 0px;"><span class="field_label" style="font-weight:500; text-align:center;">- Adóalap kedvezmények -</span></div>

                        <table style="width:100%;" cellspacing="0" cellpadding="0">
                            <tr>
                                <td><span class="field_label">Személyi kedvezmény: <span class="infobtn" @click="InfoBtnClick(5)"><i class="fas fa-info-circle"></i></span></span></td>
                                <td class="field_input" style="width:60px; padding-left: 10px;"><GrcCheckboxMobile2 ref="chkSzemelyiKedvemzeny" /></td>
                            </tr>
                            <tr>
                                <td><span class="field_label">Első házas kedvezmény: <span class="infobtn" @click="InfoBtnClick(6)"><i class="fas fa-info-circle"></i></span></span></td>
                                <td class="field_input" style="width:60px; padding-left: 10px;"><GrcCheckboxMobile2 ref="chkElsoHazasKedvezmeny" /></td>
                            </tr>
                            <tr>
                                <td><span class="field_label">Jogosult vagyok a 2021-es egyszeri családi adóvisszatérítésre:  <span class="infobtn" @click="InfoBtnClick(14)"><i class="fas fa-info-circle"></i></span></span></td>
                                <td class="field_input" style="width:60px; padding-left: 10px;"><GrcCheckboxMobile2 ref="chkVanEltartott" /></td>
                            </tr>
                            <tr>
                                <td><span class="field_label">Családi adókedvezményt veszek igénybe: <span class="infobtn" @click="InfoBtnClick(7)"><i class="fas fa-info-circle"></i></span></span></td>
                                <td class="field_input" style="width:60px; padding-left: 10px;"><GrcCheckboxMobile2 ref="chkCsaladiAdokedvezmeny" v-on:valuechanged="chkCsaladiAdokedvezmeny_click" /></td>
                            </tr>
                        </table>

                        <table style="width:100%;" cellspacing="0" cellpadding="0" v-show="IsChecked_chkCSAK">
                            <tr>
                                <td><span class="field_label" style="padding-left:30px;">Eltartott: <span class="infobtn" @click="InfoBtnClick(8)"><i class="fas fa-info-circle"></i></span></span></td>
                                <td class="field_input" style="width:50px;">
                                    <GrcNum ref="txtEltartott" v-model="txtEltartott"
                                    grc_labeltext="" grc_labelmode="nolabel" grc_labelwidth="50px"
                                    grc_currency="" grc_decimalplaces="0" grc_readonly="false"
                                    grc_textalign="right"
                                    v-on:grc-keydown-enter="SetControlToFocus('txtKedvezmenyezettEltartott');"
                                    style="width:100%;"
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td><span class="field_label" style="padding-left:30px;">Kedvezményezett eltartott: <span class="infobtn" @click="InfoBtnClick(9)"><i class="fas fa-info-circle"></i></span></span></td>
                                <td class="field_input" style="width:50px;">
                                    <GrcNum ref="txtKedvezmenyezettEltartott" v-model="txtKedvezmenyezettEltartott"
                                    grc_labeltext="" grc_labelmode="nolabel" grc_labelwidth="50px"
                                    grc_currency="" grc_decimalplaces="0" grc_readonly="false"
                                    grc_textalign="right"
                                    v-on:grc-keydown-enter="SetControlToFocus('');"
                                    style="width:100%;"
                                    />
                                </td>
                            </tr>
                        </table>



                        <div style="width:100%; box-sizing:border-box; text-align:center; margin:10px 0px 0px 0px;"><span class="field_label" style="font-weight:500; text-align:center;">- Adó visszaigénylés -</span></div>

                        <table style="width:100%;" cellspacing="0" cellpadding="0">
                            <tr>
                                <td><span class="field_label">2021-ben Egészségpénztárba befizetett összeg: <span class="infobtn" @click="InfoBtnClick(10)"><i class="fas fa-info-circle"></i></span></span></td>
                                <td class="field_input">
                                    <GrcNum ref="txtEP" v-model="txtEP"
                                    grc_labeltext="" grc_labelmode="nolabel" grc_labelwidth="100px"
                                    grc_currency="Ft" grc_decimalplaces="0" grc_readonly="false"
                                    grc_textalign="right"
                                    v-on:grc-keydown-enter="SetControlToFocus('txtNYP');"
                                    style="width:100%;"
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td><span class="field_label">2021-ben Nyugdíjpénztárba befizetett összeg: <span class="infobtn" @click="InfoBtnClick(11)"><i class="fas fa-info-circle"></i></span></span></td>
                                <td class="field_input">
                                    <GrcNum ref="txtNYP" v-model="txtNYP"
                                    grc_labeltext="" grc_labelmode="nolabel" grc_labelwidth="100px"
                                    grc_currency="Ft" grc_decimalplaces="0" grc_readonly="false"
                                    grc_textalign="right"
                                    v-on:grc-keydown-enter="SetControlToFocus('txtNYB');"
                                    style="width:100%;"
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td><span class="field_label">2021-ben Nyugdíjbiztosításra befizetett összeg: <span class="infobtn" @click="InfoBtnClick(12)"><i class="fas fa-info-circle"></i></span></span></td>
                                <td class="field_input">
                                    <GrcNum ref="txtNYB" v-model="txtNYB"
                                    grc_labeltext="" grc_labelmode="nolabel" grc_labelwidth="100px"
                                    grc_currency="Ft" grc_decimalplaces="0" grc_readonly="false"
                                    grc_textalign="right"
                                    v-on:grc-keydown-enter="SetControlToFocus('txtNYE');"
                                    style="width:100%;"
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td><span class="field_label">2021-ben Nyugdíj előtakarékossági számlára befizetett összeg: <span class="infobtn" @click="InfoBtnClick(13)"><i class="fas fa-info-circle"></i></span></span></td>
                                <td class="field_input">
                                    <GrcNum ref="txtNYE" v-model="txtNYE"
                                    grc_labeltext="" grc_labelmode="nolabel" grc_labelwidth="100px"
                                    grc_currency="Ft" grc_decimalplaces="0" grc_readonly="false"
                                    grc_textalign="right"
                                    v-on:grc-keydown-enter="SetControlToFocus('');"
                                    style="width:100%;"
                                    />
                                </td>
                            </tr>

                        </table>


                        <div class="btn_cont">
                            <div class="btn" @click="btnSzamol_click">SZÁMOL</div>
                        </div>





                    </div>
                    <div class="innerform" style="padding:0px 0px 8px 0px;" v-show="innerformid==2">
                        <table style="width:100%;" cellspacing="0" cellpadding="0">
                            <tr style="background-color: cadetblue;">
                                <td><span class="field_label" style="color:#fff;">Családi adóvisszatérítésben visszakapom:</span></td>
                                <td class="field_input">
                                    <GrcNum ref="txtCSA_Visszakapom" v-model="txtCSA_Visszakapom"
                                    grc_labeltext="" grc_labelmode="nolabel" grc_labelwidth="100px"
                                    grc_currency="Ft" grc_decimalplaces="0" grc_readonly="true"
                                    grc_textalign="right"
                                    v-on:grc-keydown-enter="SetControlToFocus('');"
                                    style="width:100%;"
                                    />
                                </td>
                            </tr>
                            <tr style="background-color: darkseagreen; display:none;">
                                <td><span class="field_label" style="color:#fff;">Még visszaigényelhető SZJA:</span></td>
                                <td class="field_input">
                                    <GrcNum ref="txtMegVisszaSZJA" v-model="txtMegVisszaSZJA"
                                    grc_labeltext="" grc_labelmode="nolabel" grc_labelwidth="100px"
                                    grc_currency="Ft" grc_decimalplaces="0" grc_readonly="true"
                                    grc_textalign="right"
                                    v-on:grc-keydown-enter="SetControlToFocus('');"
                                    style="width:100%;"
                                    />
                                </td>
                            </tr>
                        </table>

                        <table style="width:100%;" cellspacing="0" cellpadding="0">
                            <tr>
                                <td><span class="field_label">Pénztári befizetéssel nyerhető:</span></td>
                                <td class="field_input">
                                    <GrcNum ref="txtResult_SZJA" v-model="txtResult_SZJA"
                                    grc_labeltext="" grc_labelmode="nolabel" grc_labelwidth="100px"
                                    grc_currency="Ft" grc_decimalplaces="0" grc_readonly="true"
                                    grc_textalign="right"
                                    v-on:grc-keydown-enter="SetControlToFocus('');"
                                    style="width:100%;"
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td><span class="field_label">Pénztárba még befizethető:</span></td>
                                <td class="field_input">
                                    <GrcNum ref="txtResult_Osszeg" v-model="txtResult_Osszeg"
                                    grc_labeltext="" grc_labelmode="nolabel" grc_labelwidth="100px"
                                    grc_currency="Ft" grc_decimalplaces="0" grc_readonly="true"
                                    grc_textalign="right"
                                    v-on:grc-keydown-enter="SetControlToFocus('');"
                                    style="width:100%;"
                                    />
                                </td>
                            </tr>

                        </table>

                        <div class="CalcResult" v-show="(VanSZJA)&&(UrlTipus=='')">
                            Úgy néz ki <br><b>még {{ResultSZJA}}-ot visszakaphatsz az államtól!</b><br><br>Csak egy célt kell választanod
                        </div>


                        <div class="CalcResult" v-show="(VanSZJA)&&((UrlTipus=='ep')||(UrlTipus=='nyp'))">
                            Úgy néz ki <br><b>még {{ResultSZJA}}-ot visszakaphatsz az államtól,</b><br>akár már februárban, ha még idén befizetsz.
                        </div>



                        <div class="btn_cont2" v-show="VanSZJA">
                            <a class="btn2 btn2_ep" href="https://premiumegeszsegpenztar.hu/befizetek" target="_blank" v-show="(UrlTipus=='ep')">
                                <i class="far fa-money-bill-alt" style="font-size:26px; line-height:26px;margin-bottom: 10px;"></i>
                                <br>Befizetek a Prémium Egészségpénztárba
                            </a>
                            <a class="btn2 btn2_nyp" href="https://premiumnyugdijpenztar.hu/befizetek" target="_blank" v-show="(UrlTipus=='nyp')">
                                <i class="far fa-money-bill-alt" style="font-size:26px; line-height:26px;margin-bottom: 10px;"></i>
                                <br>Befizetek a Prémium Nyugdíjpénztárba
                            </a>

                            <a class="btn2 btn2_ep" href="https://landing.premiumegeszsegpenztar.hu/szjakalkulator" target="_blank" v-show="(UrlTipus=='')">
                                <i class="fas fa-hand-holding-heart" style="font-size:26px; line-height:26px;margin-bottom: 10px;"></i>
                                <br>Az egészségcél érdekel inkább
                            </a>
                            <a class="btn2 btn2_nyp" href="https://landing.premiumnyugdijpenztar.hu/szjakalkulator" target="_blank" v-show="(UrlTipus=='')">
                                <i class="fas fa-hand-holding-usd" style="font-size:26px; line-height:26px;margin-bottom: 10px;"></i>
                                <br>A nyugdíjcél érdekel inkább
                            </a>
                            
                        </div>


                        <div class="btn_cont">
                            <div class="btn btn_gray2" @click="btnVissza_click">VISSZA</div>
                        </div>


                    </div>


                </div>
            </div>
            





        </div>
        </div>
    </div>
</template>

<script>

import axios from "axios";
import GrcButton from '../GrcComponents/GrcButton.vue'
import GrcDB from '../GrcComponents/GrcDB.vue'
import GrcDialog from '../GrcComponents/GrcDialog.vue'
import GrcCombo from '../GrcComponents/GrcCombo.vue'
import GrcText from '../GrcComponents/GrcText.vue'
import GrcDate from '../GrcComponents/GrcDate.vue'
import GrcNum from '../GrcComponents/GrcNum.vue'
import GrcAdoazon from '../GrcComponents/GrcAdoazon.vue'
import GrcCheckboxMobile2 from '../GrcComponents/GrcCheckboxMobile2.vue'


export default {
  name: 'frmSZJA2021',
  components: {
      GrcButton,
      GrcDB,
      GrcDialog,
      GrcCombo,
      GrcText,
      GrcDate,
      GrcNum,
      GrcAdoazon,
      GrcCheckboxMobile2
  },
  props: {
  },
  data () {
      return {
            WSPREFIX: "frmSZJA2021",
            gPopupControlName:"",

            innerformid:1,
            title:"",
            UrlTipus:"",
            txtHaviBruttoFizetes:0,
            txtJutalomMasBer:0,
            txtOnalloJovedelem:0,
            txtKulonAdozoJovedelem:0,
            txtEgyebJovedelem:0,
            txtEltartott:0,
            txtKedvezmenyezettEltartott:0,
            IsChecked_chkCSAK:false,
            txtCSA_Visszakapom:0,
            txtMegVisszaSZJA:0,

            txtEP:0,
            txtNYP:0,
            txtNYB:0,
            txtNYE:0,

            txtResult_SZJA:0,
            txtResult_Osszeg:0,

            VanSZJA:false,
            ResultSZJA:"",

            INFOLIST:[
                "Rendszeres bér, táppénz, csecsemőgondozási díj. A kalkulátor 12 hónapi munkaviszonnyal számol. Ha nem volt egyenletes a jövedelme 2021-ben, akkor átlaggal számoljon.",
                "Egyszeri juttatások összege. Ha például két alkalommal kapott prémiumot 2021-ben, akkor azok összegét írja be",
                "Ingó és ingatlan bérbeadás, megbízási díj, felhasználói szerződés alapján keletkezett jövedelem. Azaz a bevételek költségekkel csökkentett része. <br>További info: <a href='https://nav.gov.hu/data/cms511199/2_Onallo_tevekenysegb_l_szarmazo_jovedelem_es_adozasa_20200907.pdf' target='_blank'>NAV: önálló tevékenység adózása</a>",
                "Osztalék, árfolyamnyereség, ingó és ingatlan értékesítés, kamatjövedelem, egyéni vállalkozó jövedelme. <br>További info: <a href='https://www.rsm.hu/kisokos/kulon-adozo-jovedelem' target='_blank'>Kisokos</a>",
                "Borravaló, tagi kölcsön kamata",
                "Súlyos, krónikus betegségben szenvedők kedvezménye. <br>További info: <a href='https://nav.gov.hu/nav/ado/szja/A_szemelyi_kedvezmeny20190130.html' target='_blank'>NAV: személyi kedvezmények</a>",
                "Az első házasok kedvezményére a házaspár akkor jogosult, ha legalább egyiküknek ez az első házassága. A kedvezményt a bejegyzett élettársak is igénybe vehetik. <br>További info: <a href='https://www.jogpontok.hu/kiadvanyok/Elso_hazasok_kedvezmenye.pdf' target='_blank'>Első házasok kedvezménye</a>",
                "További info: <a href='https://www.jogpontok.hu/kiadvanyok/Csaladi_ado_es_jarulekkedvezmeny_SZJA.pdf' target='_blank'>Jogpontok.hu</a>",
                "A kedvezményezett eltartott, a „kedvezményezett eltartottnak” nem minősülő vér szerinti, örökbe fogadott vagy nevelt gyermek, aki az igénylő háztartásában él, és közoktatási intézmény tanulója vagy felsőoktatási intézményben első felsőfokú szakképzésben, első alapképzésben, első mesterképzésben vagy első egységes, osztatlan képzésben részt vevő hallgató és rendszeres jövedelemmel nem rendelkezik.",
                "Akire tekintettel családi pótlékra jogosult, magzat a várandósság időszakában (fogantatásának 91. napjától megszületéséig), a rokkantsági járadékban részesülő.",
                "Ellenőrizhető Prémium Egészségpénztárban tagoknál a <a href='https://portal.premiumegeszsegpenztar.hu/' target='_blank'>portálon</a>, bejelentkezés után a főoldalon tekerj le, találsz egy adókedvezmény mutató műszert. A \"kihasznált adókedvezmény\" összegét szorozd be 5-tel és írd be ide. A kevésbé szerencsések -akik nem Prémium tagok - ellenőrizzék saját Pénztáruk oldalán, ha van erre lehetőségük. Ha több Egészségpénztárban tag valaki, a befizetett összegeket össze kell adni.",
                "Ellenőrizhető Prémium Nyugdíjpénztárban tagoknál a <a href='https://portal.premiumnyugdijpenztar.hu/portal' target='_blank'>portálon</a>, bejelentkezés után a főoldal tetején, bal oldalon találsz egy adókedvezmény mutató műszert. A \"kihasznált adókedvezmény\" összegét szorozd be 5-tel és írd be ide. A kevésbé szerencsések -akik nem Prémium tagok - ellenőrizzék saját Pénztáruk oldalán, ha van erre lehetőségük. Ha több Nyugdíjpénztárban tag valaki, a befizetett összegeket össze kell adni.",
                "Nyugdíjbiztosításra befizetett összeg. Ha valaki több kötvénnyel rendelkezik, a befizetett összegeket össze kell adni.",
                "Nyugdíj előtakarékossági számlára befizetett összeg. Ha valaki több számlával rendelkezik, a befizetett összegeket össze kell adni.",
                "Ha 2021. év bármely napján családi kedvezményre jogosult voltál, akkor is, ha a családi kedvezményt nem te veszed igénybe. Max összeg 809 000 Ft. <br>További info: <a href='https://net.jogtar.hu/jogszabaly?docid=a2100560.kor' target='_blank'>net.jogtar.hu</a>"
            ],

            
      }
  },
  model: {
  },  
  methods:{

    InfoBtnClick(pIndex)
    {
        this.ShowInfoDialog(this.INFOLIST[pIndex], "340");
    },

    SetPopupRef(pRef)
    {
        gPopupControlName = pRef;
    },

    scrollToTop() { window.scrollTo(0,0); },

    GetTextBookItem(pCompName)
    {
        return grcmain_GetTextBookItem("frmSZJA2021", pCompName);
    },

    SetControlToFocus(pNextComp)
    {
        if (pNextComp == "") { return; }


        this.$refs[pNextComp].SetFocus();
    },


    SetLang()
    {
        this.title = this.GetTextBookItem("title");

        this.Init();
    },

      HideErrors()
      {
        //this.$refs.ErrorBox.HideError();
        this.$refs.txtHaviBruttoFizetes.HideError();
      },

    chkCsaladiAdokedvezmeny_click()
    {
        this.IsChecked_chkCSAK = (this.$refs.chkCsaladiAdokedvezmeny.GetValue()==1);

        if (this.IsChecked_chkCSAK)
        {
            this.$refs.chkVanEltartott.SetValue(1);
        }
    },

    async Init()
    {
        this.InfoText = "";

        var param_refnum = "";
        if ((GRCAPP_GetParameters.ALIAS == "szja2021") && (GRCAPP_GetParameters.UT != "") && (GRCAPP_GetParameters.UT != undefined))
        {
            this.UrlTipus = GRCAPP_GetParameters.UT.toLowerCase();
        }
        
    },

    btnVissza_click()
    {
        this.scrollToTop();
        this.innerformid = 1;
    },


    PenztarSzamitas()
    {
        let Penztar = 0;
        Penztar = this.$refs.txtEP.GetValue() + this.$refs.txtNYP.GetValue();
        if (Penztar > 750000) { Penztar = 750000; }

        let NYBIZT = this.$refs.txtNYB.GetValue();
        if (NYBIZT > 650000) { NYBIZT = 650000; }

        let NYESZ = this.$refs.txtNYE.GetValue();
        if (NYESZ > 500000) { NYESZ = 500000; }

        let MaxBefMarad = 1400000 - Penztar - NYBIZT - NYESZ;

        let PenztarBefizetheto = 0;
        
        if (MaxBefMarad > 0)
        {
            PenztarBefizetheto = 750000 - Penztar;
            if (PenztarBefizetheto > MaxBefMarad) { PenztarBefizetheto = MaxBefMarad; }
        }


        let MaxSZJA = this.$refs.txtMegVisszaSZJA.GetValue();

        let PenztarResult_SZJA = 0;
        let PenztarResult_Osszeg = 0;

        if ( MaxSZJA > (Math.round(PenztarBefizetheto * 0.2)))
        {
            PenztarResult_SZJA = parseInt(Math.round(PenztarBefizetheto * 0.2));
        }
        else
        {
            PenztarResult_SZJA = MaxSZJA;
        }

        PenztarResult_Osszeg = parseInt(Math.round(PenztarResult_SZJA / 0.2));

        this.$refs.txtResult_SZJA.SetValue(PenztarResult_SZJA);
        this.$refs.txtResult_Osszeg.SetValue(PenztarResult_Osszeg);

        this.VanSZJA = (PenztarResult_SZJA>0);
        this.ResultSZJA = this.$refs.txtResult_SZJA.GetText();

        //console.log("PenztarResult_SZJA: "+PenztarResult_SZJA);
        //console.log("PenztarResult_Osszeg: "+PenztarResult_Osszeg);


    },

    async btnSzamol_click()
    {

       if ((this.$refs.txtHaviBruttoFizetes.GetValue() < 0) || (this.$refs.txtJutalomMasBer.GetValue() < 0) || (this.$refs.txtOnalloJovedelem.GetValue() < 0) || (this.$refs.txtKulonAdozoJovedelem.GetValue() < 0) || (this.$refs.txtEgyebJovedelem.GetValue() < 0))
       {
           this.ShowInfoDialog("Kérem ellenőrizze az összegeket! Az összeg nem lehet kisebb 0 Ft-nál!", 150);
           return;
       }

       if ((this.$refs.txtEP.GetValue() < 0) || (this.$refs.txtNYP.GetValue() < 0) || (this.$refs.txtNYB.GetValue() < 0) || (this.$refs.txtNYE.GetValue() < 0) )
       {
           this.ShowInfoDialog("Kérem ellenőrizze az összegeket! Az összeg nem lehet kisebb 0 Ft-nál!", 150);
           return;
       }
       

       if (this.IsChecked_chkCSAK)
       {
            if ((this.$refs.txtEltartott.GetValue() < 0) || (this.$refs.txtKedvezmenyezettEltartott.GetValue() < 0))
            {
                this.ShowInfoDialog("Kérem ellenőrizze az eltartottak számát! A szám nem lehet kisebb 0-nál!", 150);
                return;
            }

            if (this.$refs.txtEltartott.GetValue() < this.$refs.txtKedvezmenyezettEltartott.GetValue())
            {
                this.ShowInfoDialog("Az eltartottak száma nem lehet kisebb a kedvezményezett eltartottak számánál!", 150);
                return;
            }

       }


        var DialogResult = "";
        var pText = "Megpróbáltunk egy pontos, de jól használható kalkulátort készíteni, ezért kénytelenek voltunk néhány egyszerűsítéssel élni."+
        "<ul>"+
        "<li>éves rendszeres jövedelem a havi fizetés 12-szerese</li>"+
        "<li>a családi adókedvezmény számolásánál nincs lehetőség éven belül változtatni a gyerekek számát, így nem ad pontos értéket, ha az változott 2021-ben.</li>"+
        "<li>a költségelszámolást is figyelembe vevő jövedelmeknél nincs mód a bevétel és költség felvitelére, hanem egyből ennek különbségét, a jövedelmet kell rögzíteni</li>"+
        "<li>az egyes jövedelemtípusok (önálló, nem önálló, egyéb, külön adózó) rögzítését összevontuk, így például négy gyermekes anyáknál előfordulhat, hogy nem ad pontos értéket, ha nem csak nem önálló tevékenységből van jövedelmük</li>"+
        "</ul>"+
        "Ez az adóoptimalizáló riport nem szolgálja az adóbevallás alapját képező nyilvántartás célját. Az esetleges pontatlanságért vagy hibás működésért a Pénztár nem vállal felelősséget, a számolt és feltüntetett adatok tájékoztató jellegűek, nagyban függnek a bevitt adatok pontosságától.";

        var params = { title: "<i class='fas fa-info-circle' style='margin-right:6px;'></i>Információ", text: pText, color: grccomp_dialog_default_color(), width:500, height:500, padding_top:-1,
            buttons: [
                {text: "Elfogadom", value: "YES", color:"blue", width:"100px", default: false},
                {text: "Mégsem", value: "NO", color:"grey", width:"100px", default: true}
            ]
        };

        if (grccomp_getScreenSize().width < 400) { params.width = 300; }
        await this.$refs.Dialog.ShowDialog(params).then(res => 
        { 
            DialogResult = res; 
        });               

        if (DialogResult != "YES") { return; }



       let Adoalap = 0;

       Adoalap = 12 * this.$refs.txtHaviBruttoFizetes.GetValue();
       Adoalap = Adoalap + this.$refs.txtJutalomMasBer.GetValue() + this.$refs.txtOnalloJovedelem.GetValue() + this.$refs.txtEgyebJovedelem.GetValue();

       if (this.$refs.chkSzemelyiKedvemzeny.GetValue() == 1) { Adoalap = Adoalap - 669600; }
       if (this.$refs.chkElsoHazasKedvezmeny.GetValue() == 1) { Adoalap = Adoalap - 400020; }

       if (this.IsChecked_chkCSAK)
       {
           let EltartottOsszeg = 0;
           if (this.$refs.txtEltartott.GetValue() == 1) { EltartottOsszeg = 66670; }
           if (this.$refs.txtEltartott.GetValue() == 2) { EltartottOsszeg = 133330; }
           if (this.$refs.txtEltartott.GetValue() > 2) { EltartottOsszeg = 220000; }
           Adoalap = Adoalap - (12*EltartottOsszeg*this.$refs.txtKedvezmenyezettEltartott.GetValue());
       }

       let AdoalapVisszateritesNelkul = Adoalap;

       if (this.$refs.chkVanEltartott.GetValue() == 1)
       {
           Adoalap = Adoalap - 5393333; // 809000 / 0.15
       }

       if (Adoalap < 0) { Adoalap = 0; }

       //Adoalap = Adoalap + this.$refs.txtKulonAdozoJovedelem.GetValue();

        let CSA_Visszakapom = 0;

       if (this.$refs.chkVanEltartott.GetValue() == 1)
       {
           if ((AdoalapVisszateritesNelkul > 0) && (AdoalapVisszateritesNelkul <= 5393333)) { CSA_Visszakapom = Math.round(AdoalapVisszateritesNelkul * 0.15)}
           if (AdoalapVisszateritesNelkul > 5393333) { CSA_Visszakapom =Math.round( 5393333 * 0.15)}
       }

        /*
       console.log("AdoalapVisszateritesNelkul: "+AdoalapVisszateritesNelkul);
       console.log("Adoalap: "+Adoalap);
       console.log("CSA_Visszakapom: "+CSA_Visszakapom);
       console.log("Még visszaigényelhető: "+Adoalap*0.15);
       */

        this.$refs.txtCSA_Visszakapom.SetValue(parseInt(CSA_Visszakapom));
        this.$refs.txtMegVisszaSZJA.SetValue(parseInt(Math.round(Adoalap*0.15)));

        this.PenztarSzamitas();

        this.scrollToTop();
       this.innerformid = 2;


    },


    async ShowInfoDialog(pText, pHeight)
    {
        var DialogResult = "";
        var p = grccomp_dialog_alert_GetDefaults(grcmain_GetTextBookItem("tech", "informacio"), pText);             
        p.height = pHeight;
        p.width = 400;
        p.padding_top = -1;
        if (grccomp_getScreenSize().width < 400) { p.width = 300; }
        await this.$refs.Dialog.ShowDialog(p).then(res => 
        { 
            DialogResult = res; 
        });               
    },



  },

  created()
  {

  },

  mounted()
  {
    gForm = this;
    gPopupControlName = "";

    if (gAppInitDone)
    {
      this.SetLang();
    }
  }

}


</script>


<style scoped>

.maintitle
{
    width: 100%;
    box-sizing: border-box;
    color:#fff;
    font-family: "PremiumDefault";
    font-size:22px;
    line-height: 22px;
    font-weight:normal;
    text-align: left;
    padding: 10px;
}

.main_col_cont
{
    width:100%;
    box-sizing: border-box;
}

.main_col
{
    width:100%;
    box-sizing: border-box;
    display:inline-block;
    vertical-align: top;
}

.innerform
{
    width:100%;
    box-sizing: border-box;
    max-width: 620px;
    margin:0px auto;
    border: solid 1px #ccc;
    padding: 0px;
    border-radius: 0px;    
    box-shadow: 0px 0px 15px 0px rgba(0,0,0,0.25);
    -webkit-box-shadow: 0px 0px 15px 0px rgba(0,0,0,0.25);
    -moz-box-shadow: 0px 0px 15px 0px rgba(0,0,0,0.25);    
}

.field_label
{
    color: #222;
    font-family: "PremiumDefault";
    font-size:16px;
    line-height: 22px;
    font-weight:normal;
    text-align: left;
    padding: 8px;
    display: inline-block;
    box-sizing: border-box;    
}

.infotext
{
    width: 100%;
    box-sizing: border-box;
    color: var(--premblue);
    font-family: "PremiumDefault";
    font-size:16px;
    line-height: 22px;
    font-weight:normal;
    text-align: justify;
    padding: 0px 10px 0px 20px;
}

div >>> .info_title
{
    width: 100%;
    box-sizing: border-box;
    color: var(--premblue);
    font-family: "PremiumDefault";
    font-size:18px;
    line-height: 22px;
    font-weight:normal;
    text-align: left;
    padding: 10px 0px;
    font-weight: 500;
}


.btn_cont
{
  width:100%;
  box-sizing: border-box;
  padding:4px 0px;
  border-top:solid 0px #ccc;
  margin-top: 10px;
  text-align: center;
}

.btn
{
  display: inline-block;
  font-size: 16px;
  line-height: 16px;
  font-family: 'PremiumDefault';
  font-weight: normal;
  text-align: center;  
  background-color:dodgerblue;
  color:#fff;
  cursor:pointer;
  border-radius: 5px;
  margin: 2px;
  min-width: 120px;
  padding: 14px 8px 12px 8px;
}

.btn_gray2
{
  background-color: #ccc;
  color:#222;
}

.btn:hover
{
    opacity:0.9;
}

.btn_icon
{
    margin-right:4px;
}

.btn_text
{
    display:inline;
}

.btn_gray
{
  background-color: #ccc;
  color:#fff;
  cursor: default;
  opacity: 0;
}

.btn_gray:hover
{
  background-color: #ccc;
  color:#fff;
  cursor: default;
  opacity: 0;
}

.field_input
{
    width:120px;
    padding:4px 0px;
    padding-right: 8px;
}

.infobtn
{
    font-size:16px;
    line-height:16px;
    cursor:pointer;
    color:dodgerblue;
}

.infobtn:hover
{
    opacity:0.9;
}

.btn_cont2
{
    width:100%;
    box-sizing: border-box;
    text-align: center;
    max-width: 400px;
    margin:0px auto;
}

.btn2
{
  display: inline-block;
  font-size: 14px;
  line-height: 16px;
  font-family: 'PremiumDefault';
  font-weight: normal;
  text-align: center;  
  background-color:dodgerblue;
  color:#fff;
  cursor:pointer;
  border-radius: 5px;
  margin: 10px;
  width: 120px;
  padding: 14px 8px 12px 8px;
  text-decoration: none;
  vertical-align: top;
}

.btn2:visited
{
    text-decoration: none;
}

.btn2_ep
{
    background-color: var(--premblue);
}

.btn2_nyp
{
    background-color: dodgerblue;
}

.btn2:hover
{
    opacity:0.9;
}

.CalcResult
{
    width:100%;
    box-sizing: border-box;
  font-size: 14px;
  line-height: 20px;
  font-family: 'PremiumDefault';
  font-weight: normal;
  text-align: center;  
  color:royalblue;
  padding: 12px 8px;
  text-transform: uppercase;
}

@media (max-width:900px)
{
    .infotext
    {
        font-size:14px;
        line-height: 18px;
    }

}

@media (max-width:700px)
{
    .main_col
    {
        width:100%;
    }

    .infotext
    {
        font-size:14px;
        line-height: 18px;
        padding: 30px 0px 20px 0px;
    }

    .field_label
    {
        font-size:14px;
        line-height: 18px;
    }

}


</style>